import { AlertTriangle, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'

interface UserDeactivatedModalProps {
    isOpen: boolean
}

export function UserDeactivatedModal({ isOpen }: UserDeactivatedModalProps) {
    const { logout } = useAuth()

    if (!isOpen) return null

    const handleLogout = () => {
        logout()
    }

    return (
        <div className="fixed inset-0 bg-black/75 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
                <div className="text-center">
                    {/* Warning Icon */}
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
                        <AlertTriangle className="h-8 w-8 text-red-600" />
                    </div>
                    
                    {/* Title */}
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        Account Disattivato
                    </h2>
                    
                    {/* Message */}
                    <div className="text-gray-600 mb-8 space-y-3">
                        <p>
                            Il tuo account è stato temporaneamente disattivato.
                        </p>
                        <p>
                            Non puoi accedere alle funzionalità dell'applicazione fino a quando 
                            l'account non verrà riattivato da un amministratore.
                        </p>
                        <p className="text-sm">
                            Per ulteriori informazioni, contatta il supporto tecnico.
                        </p>
                    </div>
                    
                    {/* Action Button */}
                    <Button
                        onClick={handleLogout}
                        className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
                        size="lg"
                    >
                        <LogOut className="w-5 h-5 mr-2" />
                        Esci dall'Applicazione
                    </Button>
                    
                    {/* Additional Info */}
                    <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                        <p className="text-xs text-gray-500 text-center">
                            Se ritieni che si tratti di un errore, contatta l'amministratore del sistema.
                        </p>
                        <p className="text-xs text-gray-400 text-center mt-2">
                            Codice: USER_DEACTIVATED
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
